import { render, staticRenderFns } from "./newProductGoods.vue?vue&type=template&id=9f83c080&scoped=true&"
import script from "./newProductGoods.vue?vue&type=script&lang=js&"
export * from "./newProductGoods.vue?vue&type=script&lang=js&"
import style0 from "./newProductGoods.vue?vue&type=style&index=0&id=9f83c080&prod&scoped=true&lang=less&"
import style1 from "./newProductGoods.vue?vue&type=style&index=1&id=9f83c080&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f83c080",
  null
  
)

export default component.exports